module.exports = __webpack_public_path__ + "static/media/img-dentist-thumb@2x.f7669a3c.png";